import React, { useState, useEffect } from "react"
import './PortfolioComponents/Home.css'
import Home from "./PortfolioComponents/Home"
import NavBar from "./PortfolioComponents/NavBar2"
import Footer from "./PortfolioComponents/Footer"
import { BrowserRouter, Route ,Routes } from "react-router-dom";
// import rough from "./Components/rough";
// import AgencyHome from "./AgencyPortofolioComponents/AgencyHome";
import PortfolioPage from "./PortfolioComponents/PortfolioPage";
import Thanks from "./PortfolioComponents/Thanks";
import ScrollToTop from './PortfolioComponents/ScrollToTop'
import MouseFollower from "mouse-follower";
import gsap from "gsap";
import Cursor from 'react-cursor-follow'
import Calandly from './PortfolioComponents/Calandly'


function App() {

  return (
    <div >
      <BrowserRouter>
        
      <ScrollToTop></ScrollToTop>

      <NavBar></NavBar>
      <Routes>

        <Route path="/" element={<Home></Home>} />
          <Route path="/portfolio" element={<PortfolioPage></PortfolioPage>} />
          <Route path="/thankyou" element={<Thanks></Thanks>} />
          <Route path="/bookameeting" element={<Calandly></Calandly>} />



        {/* <Route path="/agency" element={<AgencyHome></AgencyHome>}/> */}

        

      </Routes>      
      <Footer></Footer>
        {/* <Cursor color="#FFBC00" className="cursors" size={120}><div><h1>View Project</h1></div></Cursor> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
